import { Box } from '@primer/react';
import React, { createContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './header';
import Menu from './menu';

export interface ILayoutContext {
    isHideSubNav?: boolean,
    setHideSubNav?: (isHidden: boolean) => void
}
export const LayoutContext = createContext<ILayoutContext>({
    isHideSubNav: false
});
interface ILayoutProps {
    children?: React.ReactNode;
}

const Layout = (props: ILayoutProps) => {
    const location = useLocation(); // Sử dụng useLocation để lấy đường dẫn
    const currentUrl = location.pathname; // Sử dụng pathname thay vì window.location.href
    const normalizedPath = currentUrl.replace(/\/+$/, '').toLowerCase();
    const isDashboardRoute = ['', '/home', '/dashboard', '/bus/dashboard'].includes(normalizedPath);
    const [isHideSubNav, setIsHideSubNav] = useState(isDashboardRoute);

    useEffect(() => {
        setIsHideSubNav(isDashboardRoute);
    }, [isDashboardRoute, normalizedPath]);

    const contextValue: ILayoutContext = useMemo(() => ({
        isHideSubNav,
        setHideSubNav: setIsHideSubNav
    }), [isHideSubNav]);

    return (
        <LayoutContext.Provider value={contextValue}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    width: '100vw',
                    overflow: 'hidden',
                    backgroundColor: 'canvas.default',
                }}
            >
                {/* Header (Top Nav + MenuGroup) */}
                <Box sx={{ flexShrink: 0, width: '100%', zIndex: 10 }}>
                    <Header />
                </Box>

                {/* Body Area */}
                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        minHeight: 0,
                        overflow: 'hidden',
                        width: '100%',
                    }}
                >
                    {/* Left Sidebar Menu */}
                    <Box
                        sx={{
                            width: isHideSubNav ? 0 : 230,
                            minWidth: isHideSubNav ? 0 : 230,
                            maxWidth: isHideSubNav ? 0 : 230,
                            display: isHideSubNav ? 'none' : 'block',
                            height: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            borderRightWidth: '1px',
                            borderRightStyle: 'solid',
                            borderRightColor: 'border.default',
                            backgroundColor: 'canvas.default',
                            py: 2,
                            px: 2,
                            flexShrink: 0,
                            boxSizing: 'border-box',
                        }}
                    >
                        <Menu />
                    </Box>

                    {/* Main Content Area */}
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            height: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            backgroundColor: 'canvas.default',
                        }}
                    >
                        {props.children}
                    </Box>
                </Box>
            </Box>
        </LayoutContext.Provider>
    );
};

export default Layout;

